export function storeFbIdCookie(formattedId: string, type: 'browser' | 'click') {
  const prefix = type === 'browser' ? 'fbp' : 'fbc';
  document.cookie = `_${prefix}=${formattedId}; path=/; max-age=${90 * 24 * 60 * 60}`;
}
